export const addressLookup = () => {

  const API_KEY = 'ca434-c8cff-7e5f7-00eb2'

  const $form = $('.js-addressForm')
  if ( !$form.length ) return
  const $postcodeButton = $('.js-addressForm__postcodeBtn')
  const $addressDropdownField = $('.js-addressForm__addressDropdown')

  const $postcodeField = $('.js-addressForm__field--postcode')
  const $address1Field = $('.js-addressForm__field--address1')
  const $address2Field = $('.js-addressForm__field--address2')
  const $cityField = $('.js-addressForm__field--city')
  const $countyField = $('.js-addressForm__field--county')

  let address = {
    address1 : '',
    address2 : '',
    postcode : '',
    city : '',
    county : '',
  }

  let lastData = null

  $postcodeButton.on('click', function(e) {
    e.preventDefault()
    const val = $postcodeField.val()

    if ( !val ) return

    const url = `https://pcls1.craftyclicks.co.uk/json/rapidaddress?key=${API_KEY}&postcode=${val}&response=data_formatted&sort=asc`

    address = {}
    lastData = null

    $.getJSON(url, function(data) {

      // temp for debugging
      console.log(data)

      if ( !$addressDropdownField.hasClass('is-ready') ) {
        $addressDropdownField.addClass('is-ready')
      }
      
      if (data.error_msg) {
        $addressDropdownField.addClass('is-invalid')
        $addressDropdownField.html(`<option value="" selected>${data.error_msg}</option>`)
        return
      }

      if ( $addressDropdownField.hasClass('is-invalid') ) {
        $addressDropdownField.removeClass('is-invalid')
      }

      lastData = data

      let options = '<option value="" selected>Choose your address from the list below</option>'
      if ( data.delivery_points.length ) {
        data.delivery_points.map(item => {
          options += `<option value="${item.line_1}">${capitalLetter(item.line_1)}</option>`
        })
      }
      $addressDropdownField.html(options)

      address.postcode = data.postcode 
      address.city = data.town
      address.county = data.traditional_county

    })
  })

  $addressDropdownField.on('change', function() {
    if ( Object.keys(address).length < 1 || !lastData ) return

    const val = $(this).val()

    if ( !lastData.delivery_points ) return

    const selectedAddress = lastData.delivery_points.find( item => val === item.line_1 )

    if ( !selectedAddress ) return

    $address1Field.val(capitalLetter(selectedAddress.line_1))
    $address2Field.val(capitalLetter(selectedAddress.line_2))
    $postcodeField.val(address.postcode)
    $cityField.val(capitalLetter(address.city))
    $countyField.val(capitalLetter(address.county))
    
  })

}

function capitalLetter(str) 
{
    if ( !str ) {
      return ''
    }

    str = str.split(' ')

    for (let i = 0, x = str.length; i < x; i++) {
        str[i] = str[i][0].toUpperCase() + ( str[i].substr(1) ? str[i].substr(1).toLowerCase() : '' )
    }

    return str.join(' ')
}